export default {
  SET_departments(state, payload) {
    state.departments = payload
  },
}
